// extracted by mini-css-extract-plugin
export default {"wrapper":"View_wrapper__T81Ca","header":"View_header__nRh76","footer":"View_footer__sVsoQ","tabs":"View_tabs__JxALF","spin":"View_spin__Bl-rt"};